export default __webpack_public_path__ + "static/gradient-top-efb6e16d61cfac8b1daf8369ea33c61d.png";